var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height general-overview-page"},[_c('div',{staticClass:"general-overview-content"},[_c('MapViewer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }